import { site } from "../../data/site";

export function Brand({ light = false }: { light?: boolean }) {
  return (
    <span className={`brand${light ? " brand-light" : ""}`}>
      <img src={site.appIcon} alt="" width="38" height="38" />
      <span>
        stratify<span className="brand-period">.</span>
      </span>
    </span>
  );
}
